export enum SabrNewIssueDecision {
	UpdatePlan = 1,
	OutOfScope = 2,
}
